const SquareUp = ({
  width = 24,
  height = 24,
  fill = "currentColor",
  ...props
}) => (
  <svg
    {...props}
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
      fill={fill}
    />
    <path
      d="M14.9999 10.26C14.8099 10.26 14.6199 10.1899 14.4699 10.0399L11.9999 7.56996L9.52994 10.0399C9.23994 10.3299 8.75994 10.3299 8.46994 10.0399C8.17994 9.74995 8.17994 9.26995 8.46994 8.97995L11.4699 5.97995C11.7599 5.68995 12.2399 5.68995 12.5299 5.97995L15.5299 8.97995C15.8199 9.26995 15.8199 9.74995 15.5299 10.0399C15.3799 10.1899 15.1899 10.26 14.9999 10.26Z"
      fill={fill}
    />
    <path
      d="M12 15.26C11.59 15.26 11.25 14.92 11.25 14.51V6.51001C11.25 6.10001 11.59 5.76001 12 5.76001C12.41 5.76001 12.75 6.10001 12.75 6.51001V14.51C12.75 14.93 12.41 15.26 12 15.26Z"
      fill={fill}
    />
    <path
      d="M12 18.2302C9.88995 18.2302 7.76995 17.8902 5.75995 17.2202C5.36995 17.0902 5.15995 16.6602 5.28995 16.2702C5.41995 15.8802 5.84996 15.6602 6.23996 15.8002C9.95996 17.0402 14.05 17.0402 17.77 15.8002C18.16 15.6702 18.59 15.8802 18.72 16.2702C18.85 16.6602 18.64 17.0902 18.25 17.2202C16.23 17.9002 14.11 18.2302 12 18.2302Z"
      fill={fill}
    />
  </svg>
);

export default SquareUp;
